/* eslint-disable eqeqeq */
/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
import { authHeaders, formatFetchErrors } from '../helpers';

export const apiService = {
  callServer,
  callServerForBlobResponse
};

function _setHeaders(requestAPI, headers) {
  const _authHeaders = Object.assign({}, ...authHeaders());

  const _apiHeaders = requestAPI.headers
    ? Object.assign({}, ...requestAPI.headers)
    : {};

  const _headers = headers ? Object.assign({}, ...headers) : {};
  const corsHeader = { 'Access-Control-Expose-Headers': '*' };
  const requestHeaders = { ..._authHeaders, ..._apiHeaders, ..._headers, ...corsHeader };
  return requestHeaders;
}

function _setURL(requestAPI, urlParams, queryParams) {
  let url = requestAPI.path;
  if (urlParams) {
    Object.keys(urlParams).map(key => {
      url = url.replace(key, urlParams[key]);
      return true;
    });
  }
  if (queryParams) {
    url = `${url}?${queryParams}`;
  }
  return url;
}

function callServer(...args) {
  return _callServerBase(handleJSONResponse)(...args);
}

function callServerForBlobResponse(...args) {
  return _callServerBase(handleBlobResponse)(...args);
}

function _callServerBase(handleResponse) {
  return (
    requestAPI,
    urlParams,
    queryParams,
    bodyParams,
    otherHeaders,
    rejectWithOriginalErrorData,
    additionalOpts = {}
  ) => {
    const headers = _setHeaders(requestAPI, otherHeaders);
    const url = _setURL(requestAPI, urlParams, queryParams);

    const requestOptions = {
      method: requestAPI.method,
      mode: 'cors',
      headers
    };
    if (bodyParams) {
      requestOptions.body = bodyParams;
    }

    return fetch(`${requestAPI.apiServer}${url}`, requestOptions)
      .then((response) => {
        return handleResponse(rejectWithOriginalErrorData)(response)
          .then(data => {
            if (additionalOpts.getResponseWithHeaders) {
              const headers = response.headers;
              const headersMap = {};
              for (const h of headers) {
                headersMap[h[0]] = h[1];
              }
              return { data, headers: headersMap };
            }
            return data;
          });
      })
      .catch((error) => {
        if (rejectWithOriginalErrorData) {
          return Promise.reject(error);
        }
        const formattedError = formatFetchErrors(error);
        return Promise.reject(`Error: ${formattedError.message}`);
      });
  };
}

function handleJSONResponse(rejectWithOriginalErrorData) {
  return (response) => {
    return response.text().then(text => {
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error('Could not parse data text');
        data = text;
      }

      if (!response.ok) {
        if (response.status === 404) {
          // might be OK to return without error...
        }

        if (rejectWithOriginalErrorData) {
          return Promise.reject(
            response.status === 404
              ? (typeof data === 'string' ? data : 'URL not found')
              : data
          );
        }

        const error = formatFetchErrors({
          fromHandler: true,
          data: text,
          res: response
        });
        console.log(`Error: ${error.message}`);
        return Promise.reject(error);
      }

      return data;
    });
  };
}

function handleBlobResponse(rejectWithOriginalErrorData) {
  return (response) => {
    if (!response.ok || response.status !== 200) {
      if (rejectWithOriginalErrorData) {
        throw new Error(
          response.status === 404 ? 'URL not found' : `Received ${response.status} status in response`
        );
      }

      const error = formatFetchErrors({
        fromHandler: true,
        data: '',
        res: response
      });
      console.log(`Error: ${error.message}`);
      return Promise.reject(error);
    }
    return response.blob(); // This can throw an error -- which is caught by the caller function
  };
}
